import React from 'react';

export const PainterTermsFull: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6 text-gray-800">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-black text-gray-900 mb-2">📜 SCI Paints BONDHU – Painter Terms & Conditions</h1>
        <p className="text-sm text-gray-600">Last updated: [01/12/2025]</p>
      </div>

      <div className="space-y-4 text-sm leading-relaxed">
        <p>
          Welcome to SCI Paints BONDHU, the official digital platform of SCI Paints.
          Our platform is designed to connect painters and dealers with the company while also streamlining communication, registration, order-related activities, and access to updates. By accessing or using the website/app, and/or by participating in the Loyalty Program, you acknowledge and agree to abide by the following Terms & Conditions.
        </p>

        <div>
          <h2 className="font-black text-lg mb-3">1. General Terms</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>These Terms govern your access to the SCI Paints website, mobile app, and loyalty program.</li>
            <li>SCI Paints reserves the right to modify, suspend, or terminate any part of the website or program at any time without prior notice.</li>
            <li>Continued use of the website or participation in the program constitutes acceptance of any updated Terms.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">2. Representations & Accuracy of Product Display</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>All colours, shades, designs, and product images shown on SCI Paints' website, app, or promotional materials are indicative only.</li>
            <li>While every effort is made to ensure accuracy, SCI Paints does not guarantee that the final product will exactly match the representation shown.</li>
            <li>Painters are advised to verify using physical samples or testers before final use.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">3. Loyalty Program – Overview</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>The SCI Paints BONDHU Loyalty Program allows registered painters to earn cash rewards and points by scanning unique, one-time-use coupons provided with SCI Paints materials (inside or outside the packaging).</li>
            <li>Collected cash and points will be reflected separately in the painter's wallet.</li>
            <li><strong>Cash Rewards:</strong> Painters can withdraw earned cash, subject to applicable service fees and TDS deductions as per government guidelines.</li>
            <li><strong>Points:</strong> Points can be redeemed for gifts decided by the company. In future, SCI Paints may, at its discretion, allow conversion of points into monetary rewards — with or without prior notification.</li>
            <li>The loyalty points/rewards displayed in the website/app/software are indicative only. The final calculation will be based on SCI Paints' internal database.</li>
            <li>SCI Paints' decision on rewards, eligibility, and point calculation shall be final and binding on all participants.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">4. Eligibility & Registration</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>The program is open only to professional painters/contractors residing in India.</li>
            <li>Participants must provide valid Aadhaar, bank account, and contact information during registration.</li>
            <li>SCI Paints reserves the right to reject, suspend, or terminate any registration that contains incomplete, false, or unverifiable information.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">5. Bank Account & Withdrawal Policy</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Rewards and payouts will be credited only to the registered bank account.</li>
            <li>Painters may update or edit their bank details in their profile at any time.</li>
            <li>SCI Paints will not be responsible for any payment failure, incorrect transfer, or fraud resulting from inaccurate or unauthorized changes in account information.</li>
            <li>The company will assume that any modification of bank details is done voluntarily and knowingly by the painter.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">6. Service Charges & Deductions</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Every transaction under the program is subject to service, processing, or maintenance fees, which will be deducted from the payout.</li>
            <li>Applicable TDS (Tax Deducted at Source) will be deducted where required by law.</li>
            <li>The percentage and structure of these deductions may be revised by SCI Paints at any time, with or without prior notice.</li>
            <li>All deductions are final and non-refundable.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">7. Restrictions & Misuse</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>The website/app or loyalty program must not be used for any unlawful activity.</li>
            <li>Fraudulent behaviour, such as duplicate scanning of coupons, tampering, or use of fake materials, will lead to permanent disqualification from the program and possible legal action.</li>
            <li>SCI Paints reserves the right to cancel rewards, suspend accounts, or terminate participation at its sole discretion in case of suspected misuse.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">8. Data Collection & Privacy</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>SCI Paints collects and stores personal information, including KYC documents, contact, and banking details, solely for administering the program and issuing rewards.</li>
            <li>Personal data will not be shared with any third party except as required for legal compliance or payment processing.</li>
            <li>By participating, you consent to SCI Paints' data usage and storage practices in accordance with these terms.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">9. Limitation of Liability</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>SCI Paints will not be liable for any technical issues, transaction failures, delays, or losses arising from system errors, internet connectivity, or third-party payment gateways.</li>
            <li>The company shall not be responsible for any loss of rewards or points due to user error, system malfunction, or program changes.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">10. Indemnity</h2>
          <p className="ml-4">
            By participating, you agree to indemnify and hold harmless SCI Paints, its proprietor, employees, and authorized representatives from any claims, damages, or losses resulting from:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-8">
            <li>Violation of these Terms;</li>
            <li>Misuse of the website/app;</li>
            <li>Fraudulent activities related to coupon scanning or registration.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">11. Governing Law & Dispute Resolution</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Any dispute or difference shall first be attempted to be resolved amicably within 60 working days.</li>
            <li>If unresolved, it shall be referred to arbitration under the Arbitration and Conciliation Act, 1996, by a sole arbitrator appointed by the Proprietor of SCI Paints.</li>
            <li>The arbitration shall be conducted in English, and the venue shall be Serampore, West Bengal.</li>
            <li>Courts in Serampore, West Bengal, shall have exclusive jurisdiction.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">12. Intellectual Property</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>All website/app content, including trademarks, images, and text, are the exclusive property of SCI Paints.</li>
            <li>Unauthorized copying, distribution, or use is strictly prohibited.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">13. Program Modification or Termination</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>SCI Paints reserves the right to modify, suspend, or terminate the loyalty program or any part of it at any time, with or without notice.</li>
            <li>Upon termination, all accumulated points/rewards shall lapse unless otherwise announced by the company.</li>
          </ul>
        </div>

        <div>
          <h2 className="font-black text-lg mb-3">14. Support</h2>
          <p className="ml-4">
            For queries, discrepancies, or clarifications related to the program or website, painters can contact:
          </p>
          <ul className="list-none space-y-1 ml-8 mt-2">
            <li>📧 scipaints.sales@gmail.com, scipaints@gamil.com</li>
            <li>📞 +91 7044348595</li>
          </ul>
          <p className="ml-4 mt-2">
            SCI Paints will make reasonable efforts to resolve such matters promptly and fairly.
          </p>
        </div>
      </div>
    </div>
  );
};

